import React, { useContext, useEffect, useMemo, useState, useRef } from 'react';
import ReactDOMServer from 'react-dom/server';
import axios from "axios";
import { Link, navigate, useQueryParams } from 'raviger';
import { Button, Card, CardGroup, Col, Collapse, Form, FormControl, InputGroup, ListGroup, Modal, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBan, faInfoCircle, faGlobe, faCut, faEnvelope, faLink, faMapMarkerAlt, faMedkit, faUserAltSlash,
  faCaretDown,
  faChevronDown
} from '@fortawesome/free-solid-svg-icons';
import {
  faDotCircle
} from '@fortawesome/free-regular-svg-icons';
import { Typeahead, Menu, MenuItem } from 'react-bootstrap-typeahead';
import { faHandsHolding, faChevronDoubleDown, faChevronDoubleUp, faClawMarks, faFolderMedical, faPhoneRotary } from '@fortawesome/pro-solid-svg-icons';
import Select, { components } from 'react-select';
import L from "leaflet";
import { Circle, MapContainer, Marker, Tooltip as MapTooltip, ScaleControl, TileLayer, useMap, useMapEvents } from "react-leaflet";
import { useMark, useSubmitting, useDataImg, useLocationWithRoutes } from '../hooks';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import Stack from '@mui/material/Stack';
import Header from '../components/Header';
import Scrollbar from '../components/Scrollbars';
import { titleCase } from '../components/Utils';
import { ITEMS_PER_PAGE } from '../constants';

function Paginator({page, numPages, setPage}) {

  return (
    <>
    <Stack spacing={2}>
			<Pagination page={page} count={numPages} size="large" variant="outlined" onChange={(e) => {setPage(parseInt(e.target.innerText))}} 
				renderItem={(item) => {
					if (item.type === 'start-ellipsis' || item.type === 'end-ellipsis') {
						return (
							<PaginationItem
								className="ellipsis-page-links"
								{...item}
							/>
						);
					}
					if (item.type === 'previous') {
						return (
							<PaginationItem
								className="custom-page-links"
								{...item}
								onClick={() => {setPage(parseInt(item.page))}}
							/>
						);
					}
					if (item.type === 'next') {
						return (
							<PaginationItem
								className="custom-page-links"
								{...item}
								onClick={() => {setPage(parseInt(item.page))}}
							/>
						);
					}
					// Default rendering for page numbers
					return <PaginationItem className="custom-page-links" active={Number(item.page) === Number(page)} shape="rounded" {...item} />;
				}}
				sx={{
					'& .MuiPaginationItem-root': {
						fontSize: '1.5rem',      // Make numbers/arrows bigger
						minWidth: '50px',        // Widen the buttons
						height: '50px',          // Taller buttons
						borderRadius: '5px',    // Keeps it circular or rounded
						margin: '0 7px',         // Adds more space between items
					},
					'& .MuiPaginationItem-icon': {
						fontSize: '2rem',        // Specifically enlarges the arrow icons
					},
					// width: '100%', display: 'flex', justifyContent: 'center' 
				}}
			>
			</Pagination>
		</Stack>
    </>
  );
};

export default Paginator;
